import SetupSecurityQuestionsForm from './SetupSecurityQuestionsFormContainer';

export default SetupSecurityQuestionsForm;